export const XBIT_RELAY_HOT_WALLETS_PERMISSION_RESOURCE = 'xbit-relay:hot-wallets';
export const XBIT_RELAY_PROVIDERS_PERMISSION_RESOURCE = 'xbit-relay:providers';

export const HYPERLIQUID_CHAIN_ID = 999;
export const TRON_CHAIN_ID = 728126428;

/**
 * Hyperliquid hot wallets carry no threshold config at all — alert and rebalance controls alike
 * are read-only there.
 */
export const ALERT_CONFIG_LOCKED_CHAIN_IDS = [HYPERLIQUID_CHAIN_ID] as const;

/**
 * Tron keeps its alert fields but cannot rebalance, so the ceiling/target/switch are read-only.
 * Hyperliquid is locked here too — a chain with no config at all also has no rebalance config.
 */
export const REBALANCE_CONFIG_LOCKED_CHAIN_IDS = [HYPERLIQUID_CHAIN_ID, TRON_CHAIN_ID] as const;
